import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import PageWrapper from '../PageWrapper'
import hmenu_user from "../../common/images-new/no-profile-pic.png";
import ButtonBlue from '../../components/Button/ButtonBlue';
import axios from 'axios';
import { apiAuthorizeKey, serverUrl } from '../../components/Helpers/Config';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import $ from "jquery";
import { setUserPhoto, updateProfile } from '../../redux/actions/auth';
import { getUserNavigationConfrimPopup } from "../../redux/actions/commonAction";
import { Card } from '../Theme';
import Toggle from "../../components/Button/Toggle";
import CustomizedToggle from "../../components/Button/ToggleButton";
import ModalProfile from "../../components/Modal/ModalProfile";
import { tokenAuthorize } from '../../components/Helpers/Common';
import { staticFiles } from '../../components/Helpers/Static';
import ButtonCommon from '../../components/Button/ButtonCommon';
import { ButtonCommonTopNew, ButtonCommonTopGrey, PrivacyContainer, IconContainerGreen, IconContainerBlue, PreferenceContainer } from '../../pages/Theme';
import ModalTermsAndPolicy from '../../components/Modal/ModalTermsandPolicy';
import CameraIcon from "../../common/images-new/camera-icon.png"

const AccountSettings = () => {

    const profilePhotoRef = useRef();
    const history = useHistory();
    const [displayEmail, setDisplayEmail] = useState("")
    const [secondaryEmail, setSecondaryEmail] = useState("")
    const [secondaryEmailValid, setSecondaryEmailValid] = useState(false)
    const userProfile = useSelector(state => state.auth.user)
    const dispatch = useDispatch();

    const [showProfile, setShowProfile] = useState(false)
    const [show, setShow] = useState(false)

    const [profilePhoto, setProfilePhoto] = useState(userProfile ? userProfile.photo : hmenu_user);
    const [profilePhotoFile, setProfilePhotoFile] = useState(null);
    const [isVisible, setisVisible] = useState();
    const [message, setmessage] = useState();
    const [privacyPolicy, setPrivacyPolicy] = useState();
    const [policyContent, setPolicyContent] = useState({
        modal: false,
        content: '',
        header: ''
    });
    const [is_weekly_digest_required, SetWeekly_digest_required] = useState(false);
    const [isEmailVisible, SetEmailVisible] = useState(false);
    useEffect(() => {
        dispatch(getUserNavigationConfrimPopup(false));
        axios.get(serverUrl.EditProfile, { headers: { 'x-api-key': apiAuthorizeKey } }).then(res => {
            if (res.status === 200) {
                let profile_consent = res.data.profile_consent;
                setisVisible(profile_consent.canVisible);
                let PrivacyPolicyMessage = profile_consent?.message.replace(`<span class="termsAndConditions" id="profileConsentPrivacyPolicy"/>`,
                    `<span class="termsAndConditions text-sm font-semibold mt-2 hover:underline" id="profileConsentPrivacyPolicy">${profile_consent?.DisplayLabel}</span>`
                );
                setmessage(PrivacyPolicyMessage);
                setPrivacyPolicy(profile_consent.Policies || '');
            }
        }).catch(err => {
            console.log(err);
        })
    }, []);
    useEffect(() => {
        $(document).on("click", ".termsAndConditions", function () {
            setPolicyContent({
                content: privacyPolicy,
                modal: true,
                header: $(this).text() != "" ? $(this).text() : "Privacy Policy"
            });
        });

        return () => {
            $(document).off("click", ".termsAndConditions"); // Cleanup event listener
        };
    });

    useEffect(() => {
        axios.get(serverUrl.ProfileSettings).then(res => {
            if (res.status === 200) {
                SetEmailVisible(res?.data?.results?.display_email);
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            console.log(err);
        })
    }, []);

    const profile = {
        name: userProfile ? userProfile.fullname : '',
        email: userProfile ? userProfile.email : '',
        secondaryEmail: userProfile ? userProfile.secondary_email : '',
        displayEmail: userProfile ? userProfile.display_email : '',
        programme: userProfile ? userProfile.programme : '',
        photo: userProfile ? userProfile.photo : hmenu_user,
    }

    let isNIE = false;
    if (profile.email.length > 10) {
        const partEmail = profile.email.substring(profile.email.length - 10).toLowerCase();

        if (partEmail === "nie.edu.sg") {
            isNIE = true;
        }
    }

    useEffect(() => {
        if (profilePhotoFile) {
            const objectURL = URL.createObjectURL(profilePhotoFile);
            setProfilePhoto(objectURL);
            return () => URL.revokeObjectURL(objectURL);
        }
    }, [profilePhotoFile]);

    useEffect(() => {
        setDisplayEmail(userProfile.display_email)
        setSecondaryEmail(userProfile.secondary_email)
        SetWeekly_digest_required(userProfile.is_weekly_digest_required);
    }, [userProfile])

    const handleProfileImageChange = (e) => {
        const fileObj = e.target.files[0];
        if (!fileObj) return;
        setProfilePhotoFile(fileObj);
        setShowProfile(true)
    }

    const saveData = () => {
        const showError = () => {
            Swal.fire({
                heightAuto: false,
                title: "Error",
                text: "Cannot update profile",
                icon: "error",
            });
        }

        const showWhitelistError = () => {
            Swal.fire({
                heightAuto: false,
                title: "Information",
                text: "Email domain for External Email Address is not allowed. Please check with DP Admin",
                icon: "info",
            });
        }

        axios.get(serverUrl.VerifyWhitelist + '/' + secondaryEmail)
            .then(res => {
                if (res.status === 200) {
                    let resp = res.data;
                    setSecondaryEmailValid(resp);
                    if (resp) {
                        axios.put(serverUrl.ProfileUpdateEmail, {
                            email: displayEmail,
                            secondary_email: secondaryEmail,
                            is_weekly_digest_required: is_weekly_digest_required
                        }).then((resp) => {
                            if (resp.status === 200) {
                                dispatch(updateProfile({
                                    display_email: displayEmail,
                                    secondary_email: secondaryEmail,
                                    is_weekly_digest_required: is_weekly_digest_required
                                }))

                                Swal.fire({
                                    heightAuto: false,
                                    title: "Success",
                                    text: "Profile has been updated",
                                    icon: "success",
                                    showCancelButton: false,
                                    showDenyButton: true,
                                    confirmButtonText: "To Home",
                                    denyButtonText: "Continue Editing",
                                    confirmButtonColor: "#3085d6",
                                    denyButtonColor: "#c1c1c1",
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        history.push("/");
                                    } else if (result.isDenied) {
                                        Swal.close();
                                    }
                                });
                            }
                            else {
                                showError();
                            }
                        })
                            .catch((err) => {
                                tokenAuthorize(err?.response?.status);
                                showError();
                            })
                    }
                    else {
                        showWhitelistError();
                    }
                }
            })
            .catch((err) => {
                tokenAuthorize(err?.response?.status);
                showError();
            })


    }

    const isDataChanged = (
        (profile.displayEmail !== displayEmail) &&
        (profile.secondaryEmail !== secondaryEmail)
    );

    const handleDiscardData = () => {
        setDisplayEmail(userProfile.display_email)
        setSecondaryEmail(userProfile.secondary_email)
        SetWeekly_digest_required(userProfile.is_weekly_digest_required);
        if (isDataChanged) {
            Swal.fire({
                icon: "info",
                title: "Info",
                text: "There were no changes made",
            });
        }

    }

    const handleProfileUpload = () => {
        profilePhotoRef.current.value = "";
        profilePhotoRef.current.click();
    }

    return (<>
        <PageWrapper>
            <div className='cardBackgroundColor border20px md:mt-4 md:mb-6  mt-1 mb-3'>

                <div className="rounded-2xl shadow-sm overflow-hidden">
                    <div className="flex flex-col min-h-[600px]">
                        {/* <div className="flex flex-col lg:flex-row min-h-[600px]"> */}
                        {/* <div className="lg:w-2/5 bg-gradient-to-br from-blue-600 to-indigo-600 p-8 flex flex-col items-center justify-center text-white relative"> */}
                        <div className="blueBackGroundColor p-8 flex flex-col items-center justify-center text-white relative">

                            <div className="text-center">
                                <div className="relative group mb-6">
                                    <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-white shadow-2xl" >
                                        <img
                                            src={profile.photo ? profile.photo : staticFiles?.noProfilePic}
                                            alt="Profile"
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                    <button className="absolute bottom-2 right-2 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-all group-hover:scale-110 duration-200" onClick={() => handleProfileUpload()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-camera-icon lucide-camera w-5 h-5 text-gray-600"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" /><circle cx="12" cy="13" r="3" /></svg>
                                    </button>
                                    <input
                                        className="hidden"
                                        ref={profilePhotoRef}
                                        type="file"
                                        accept="image/gif, image/jpeg, image/jpg, image/png"
                                        onChange={handleProfileImageChange}
                                    />
                                </div>
                            </div>
                            <div className="text-center">
                                <h2 className="text-2xl font-bold mb-2">{profile.name || 'User'}</h2>
                                {/* <p className="text-blue-100 text-sm mb-6">Student Profile</p> */}

                                <div className="w-16 h-1 bg-white/30 rounded-full mx-auto"></div>
                            </div>

                            {/* circles
              <div className="absolute top-8 left-8 w-20 h-20 border border-white/20 rounded-full"></div>
              <div className="absolute bottom-8 right-8 w-12 h-12 border border-white/20 rounded-full"></div> */}
                        </div>


                        {/* <div className="lg:w-3/5 p-8"> */}
                        <div className="p-8">
                            <div className="h-full flex flex-col justify-between">

                                <div className="space-y-8">
                                    {/* Personal Information Section */}
                                    <div>
                                        <div className="flex items-center gap-3 mb-6">
                                            <IconContainerBlue className='p-2 rounded-lg'>

                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-user-icon lucide-user w-5 h-5"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>

                                            </IconContainerBlue>
                                            <h3 className="text-lg font-semibold blackColor">Personal Information</h3>
                                        </div>

                                        <div className="space-y-6">
                                            <div>
                                                <label className="block text-sm font-semibold blackColor mb-2">
                                                    Full Name
                                                </label>
                                                <div className="relative">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-id-card-icon lucide-id-card absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"><path d="M16 10h2" /><path d="M16 14h2" /><path d="M6.17 15a3 3 0 0 1 5.66 0" /><circle cx="9" cy="11" r="2" /><rect x="2" y="5" width="20" height="14" rx="2" /></svg>

                                                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-user-icon lucide-user absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg> */}
                                                    <input
                                                        type="text"
                                                        defaultValue={profile.name}
                                                        readOnly={true}
                                                        disabled
                                                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg"
                                                        placeholder="Enter your full name"
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <label className="block text-sm font-semibold blackColor mb-2">
                                                    NIE Email Address
                                                </label>
                                                <div className="relative">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-mail absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
                                                    <input
                                                        type="email"
                                                        value={isNIE ? profile.email : ""}
                                                        readOnly={true}
                                                        disabled
                                                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg"
                                                        placeholder="your.email@nie.ac.in"
                                                    />
                                                </div>
                                            </div>
                                            {isEmailVisible &&
                                                <div>
                                                    <label className="block text-sm font-semibold blackColor mb-2">
                                                        Display Email Address
                                                    </label>
                                                    <div className="relative">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-mail absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
                                                        <input
                                                            type="email"
                                                            value={displayEmail}
                                                            onChange={(e) => { setDisplayEmail(e.currentTarget.value) }}
                                                            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg"
                                                            placeholder="your.email@nie.ac.in"
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            <div>
                                                <label className="block text-sm font-semibold blackColor mb-2">
                                                    Secondary Login Account
                                                </label>
                                                <div className="relative">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-mail absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
                                                    <input
                                                        type="email"
                                                        value={secondaryEmail}
                                                        onChange={(e) => { setSecondaryEmail(e.currentTarget.value) }}
                                                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg"
                                                        placeholder="your.email@gmail.com"
                                                    />
                                                </div>
                                            </div>
                                            {/* Privacy Notice */}
                                            <PrivacyContainer className='p-4 rounded-lg'>
                                                <div className="flex items-start gap-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-icon lucide-shield w-5 h-5 mt-0.5 flex-shrink-0"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" /></svg>
                                                    <div>
                                                        <h4 className="font-semibold mb-1">Privacy Notice</h4>
                                                        <p className="text-sm privacyNotice" dangerouslySetInnerHTML={{ __html: message }}>

                                                        </p>

                                                    </div>
                                                </div>
                                            </PrivacyContainer>

                                        </div>
                                    </div>

                                    {/* Preferences Section */}
                                    <div>
                                        <div className="flex items-center gap-3 mb-6">
                                            <IconContainerGreen className='p-2 rounded-lg'>

                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-bell-icon lucide-bell w-5 h-5"><path d="M10.268 21a2 2 0 0 0 3.464 0" /><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" /></svg>


                                            </IconContainerGreen>

                                            <h3 className="text-lg font-semibold blackColor">Preferences</h3>
                                        </div>
                                        <PreferenceContainer className='p-6 rounded-lg'>
                                            <div className="flex items-center justify-between">
                                                <div className="flex-1">
                                                    <h4 className="font-semibold blackColor mb-1">Weekly Digest Emails</h4>
                                                    <p className="text-sm lightGray">
                                                        Receive regular email updates about your Digital Portfolio activities.
                                                    </p>
                                                    {isNIE && profile.email && <>
                                                        <p className="text-sm lightGray mb-2">Messages will be sent to your primary email address {isNIE ? profile.email : ""}.</p>
                                                    </>
                                                    }
                                                </div>
                                                <CustomizedToggle
                                                    checked={is_weekly_digest_required}
                                                    onChange={() => SetWeekly_digest_required(!is_weekly_digest_required)}
                                                />

                                            </div>
                                        </PreferenceContainer>

                                    </div>

                                </div>

                                {/* Action Buttons */}
                                <div className="flex flex-col sm:flex-row sm:justify-end gap-4 pt-8">
                                    <button
                                        onClick={saveData}
                                        className="flex-1 sm:flex-none buttonColor text-white font-medium px-5 py-2 rounded-lg"
                                    >
                                        Save Changes
                                    </button>
                                    {
                                        isDataChanged &&
                                        <ButtonCommonTopGrey
                                            className={`${'px-5 rounded-lg py-2 flex justify-center items-center font-semibold hover:bg-gray-200'}`}
                                            onClick={handleDiscardData}
                                        >
                                            Discard
                                        </ButtonCommonTopGrey>

                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {/* Modals */}
            {policyContent.modal &&
                <ModalTermsAndPolicy
                    showPolicyModal={policyContent?.modal}
                    PolicyContent={policyContent}
                    setShowPolicyModal={() => setPolicyContent({
                        content: '',
                        modal: false,
                        header: ''
                    })}
                />}
            <ModalProfile
                show={showProfile}
                setShow={setShowProfile}
                imgSrc={profilePhoto}
                editCover={false}
                editBanner={false}
            />
        </PageWrapper>
    </>
    )
}

export default AccountSettings;